module.exports = __webpack_public_path__ + "static/assets/feeb309c99c295b53e52630894591094.svg";